import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"

const gsapNavbar = {};

gsapNavbar.init = () => {
    gsap.registerPlugin(ScrollTrigger);

    const eleHeader = document.getElementById('main-navbar');

    function headerPin() {
        eleHeader.classList.remove('header-unpin');
        eleHeader.classList.add('header-pin');
    }
    function headerUnpin() {
        eleHeader.classList.remove('header-pin');
        eleHeader.classList.add('header-unpin');
    }
    function headerBackground() {
        eleHeader.classList.toggle('header-background');
    }

    if (eleHeader) {

        let startElem;

        ScrollTrigger.matchMedia({
            // desktop
            "(min-width: 1024px)": function() {
                startElem = "100px 50px";
            },
            // mobile
            "(max-width: 1023px)": function() {
                startElem = "50px 30px";
            }
        })
        ScrollTrigger.create({
            start: startElem,
            end: 99999,
            onUpdate: (self) => {
                (self.direction === -1 && !document.body.classList.contains('no-navbar-animation')) ?
                    headerPin() :
                    headerUnpin()
            },
            onToggle: () => headerBackground()
        });
    }

};

export default gsapNavbar;
